import type { ReactNode } from "react";
import "./SiteCalendarEvents.scss";
import IconPartyPopperOutline from "@/shared/components/generic/icons/IconPartyPopperOutline.tsx";
import { useTranslation } from "react-i18next";
import type { CalendarDay } from "@/pages/human-resources/time-management/business/calendar/CalendarDay.ts";
import IconHouseCross from "@/shared/components/generic/icons/IconHouseCross.tsx";
import IconCalendar from "@/shared/components/generic/icons/IconCalendar.tsx";
import IconClockBackwardCircleArrow from "@/shared/components/generic/icons/IconClockBackwardCircleArrow.tsx";

interface Properties {
  calendarDay: CalendarDay;
  timeChange: boolean;
}

export default function SiteCalendarEvents(props: Properties): ReactNode {
  const { t } = useTranslation(["humanResources"]);
  return (
    <div className="site-calendar-events">
      {props.calendarDay.publicHoliday !== undefined && (
        <div>
          <IconPartyPopperOutline />
          <div>{props.calendarDay.publicHoliday}</div>
        </div>
      )}
      {props.calendarDay.isClosed && (
        <div>
          <IconHouseCross />
          <div>{t("common.closedSite")}</div>
        </div>
      )}
      {props.calendarDay.events.map((e, index) => (
        <div key={`event_${index}`}>
          <IconCalendar />
          <div>{e.name}</div>
        </div>
      ))}
      {props.timeChange && (
        <div>
          <IconClockBackwardCircleArrow />
          <div>{t("common.timeChange")}</div>
        </div>
      )}
    </div>
  );
}
